<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Payment.Level.Account.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mr-sm-2" for="sAccountName">Account Name </label>
              <b-input id="sAccountName" type="text" placeholder="" v-model.trim="sAccountName"></b-input>
              &nbsp;&nbsp;
              <label class="mx-sm-2" for="sVIPLevel">Level </label>
              <b-form-select id="sVIPLevel" :plain="true" :options="levels" v-model="sVIPLevel" text-field="Name" value-field="Id">
                <template slot="first">
                  <option :value="null">-- Please select an option --</option>
                </template>
              </b-form-select>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" @click="searchVIPLevelAccount"><i class="fa fa-search"></i> Search</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-user'></i> VIP Level - Account</h3>
              <b-button variant="primary" class="float-right" @click="showManagementModal" v-if="checkAccessPrivilege('Payment.Level.Account.Management')">VIP Level Management</b-button>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(action)="data">
                <b-button variant="warning" v-if="checkAccessPrivilege('Payment.Level.Account.Change')" @click="showChangeVIPLevel(data.item.Id, data.item.LevelId, data.item.AccountId, data.item.AccountName)">Change</b-button>
                <b-button variant="danger" v-if="checkAccessPrivilege('Payment.Level.Account.Remove')" @click="showRemoveVIPLevel(data.item.Id)">Remove</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="changeVIPLevel" size="lg" centered header-bg-variant="primary" hide-footer title="Change VIP Level">
          <div class="mb-3">
            <label for="cVIPLevel">Level</label>
            <b-form-select id="cVIPLevel" :plain="false" v-model="cVIPLevel" :state="$v.cVIPLevel.$error?false:null" @blur.native="$v.cVIPLevel.$touch">
              <option :value="null">-- Please select --</option>
              <option v-for="d in levels" :key="d.Id" :value="d.Id">{{ d.Name }}</option>
            </b-form-select>
            <div v-if="$v.cVIPLevel.$error">
              <div class="invalid-feedback d-block" v-if="!$v.cVIPLevel.required">VIP level is required</div>
            </div>
          </div>
          <b-button variant="success" @click="changeVIPLevel" :disabled="$v.cVIPLevel.$invalid">Confirm</b-button>
          <b-button variant="outline-danger" @click="cancelChangeVIPLevel">Cancel</b-button>
    </b-modal>
    <b-modal ref="showManagementModal" size="lg" header-bg-variant="primary" hide-footer title="VIP Level Management">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!$v.searchName.$error">
                      <b-input-group>
                        <b-form-input type="text" placeholder="Enter Account Name for Search" v-model.trim="searchName" :state="$v.searchName.$error?false:null" @focus.native="$v.searchName.$touch"></b-form-input>
                        <b-input-group-button class="input-group-append">
                          <b-btn variant="success" @click="searchAccount" :disabled="$v.searchName.$invalid">
                            <i class="fa fa-search"></i> Search
                          </b-btn>
                        </b-input-group-button>
                      </b-input-group>
                      <div v-if="$v.searchName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.searchName.required">Account name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.searchName.minLength">Must have at least {{ $v.searchName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.searchName.maxLength">Must no exceed {{ $v.searchName.$params.maxLength.max}} letters</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="accounts" :fields="accountFields" :current-page="accountCurrentPage" :per-page="accountPerPage">
                      <template v-slot:cell(action)="data">
                        <b-button variant="danger" @click="confirmAssignLevel(data.item.Id, data.item.Name)">Assign</b-button>
                      </template>
                    </b-table>
                    <nav>
                      <b-pagination :total-rows="getAccountRowCount(accounts)" :per-page="accountPerPage" v-model="accountCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="outline-danger" @click="hideManagementModal">Cancel</b-btn>
    </b-modal>
    <b-modal ref="confirmAssignLevel" @hidden="onAssignModalHide" size="lg" centered header-bg-variant="primary" hide-footer title="Assign VIP Level">
          <div class="mb-3">
            <label for="aVIPLevel">Level</label>
            <b-form-select id="aVIPLevel" :plain="false" v-model="aVIPLevel" :state="$v.aVIPLevel.$error?false:null" @blur.native="$v.aVIPLevel.$touch">
              <option :value="null">-- Please select --</option>
              <option v-for="d in levels" :key="d.Id" :value="d.Id">{{ d.Name }}</option>
            </b-form-select>
            <div v-if="$v.aVIPLevel.$error">
              <div class="invalid-feedback d-block" v-if="!$v.aVIPLevel.required">VIP level is required</div>
            </div>
          </div>
          <b-button variant="success" @click="assignVIPLevel" :disabled="$v.aVIPLevel.$invalid">Confirm</b-button>
          <b-button variant="outline-danger" @click="cancelAssignLevel">Cancel</b-button>
    </b-modal>
    <b-modal ref="removeVIPLevel" size="lg" centered header-bg-variant="danger" hide-footer title="Remove VIP Level">
          <div class="mb-3">
            <p>Are you sure to remove this account from VIP level group?</p>
          </div>
          <b-button variant="success" @click="removeVIPLevel">Yes</b-button>
          <b-button variant="outline-danger" @click="cancelRemoveLevel">No</b-button>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'vip-level-account-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        accounts: [],
        levels: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'AccountName', label: 'Account Name'},
          {key: 'LevelName', label: 'Level'},
          {key: 'action', label: 'Action'}
        ],
        accountFields: [
          {key: 'Id', label: 'ID'},
          {key: 'Name', label: 'Account Name'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        accountCurrentPage: 1,
        perPage: 10,
        accountPerPage: 10,
        totalAccountRows: 0,
        operator: '',
        searchName: '',
        changeId: '',
        cAccountId: '',
        cAccountName: '',
        cVIPLevel: null,
        sAccountName: '',
        sVIPLevel: null,
        assignId: '',
        assignAccountName: '',
        aVIPLevel: null,
        removeId: ''
      }
    },
    validations: {
      searchName: { required, minLength: minLength(1), maxLength: maxLength(30) },
      cVIPLevel: { required },
      aVIPLevel: { required }
    },
    watch: {
      currentPage: function () {
        this.searchVIPLevelAccount()
      },
      currentAccountPage: function () {
        this.searchAccount()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      getAccountRowCount (accounts) {
        return accounts.length
      },
      getVIPLevels () {
        this.$http.get(this.API_ENDPOINT + '/payment/viplevel/levels', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.levels = response.data.levels
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllVIPLevelAccountData () {
        this.$http.get(this.API_ENDPOINT + '/payment/viplevel/account/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.items
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      searchAccount () {
        this.$http.post(this.API_ENDPOINT + '/payment/bank/account/search', {searchName: this.searchName}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.accounts = response.data.accounts
          this.totalAccountRows = response.data.accounts.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      searchVIPLevelAccount () {
        let accountName = this.sAccountName
        let vipLevel = this.sVIPLevel
        if (accountName === '' && vipLevel === null) {
          this.getAllVIPLevelAccountData()
          return
        }
        let queryStr = `?accountName=${accountName}&level=${(vipLevel === null) ? '' : vipLevel}`
        this.$http.get(this.API_ENDPOINT + '/payment/viplevel/account/search' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.items
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      changeVIPLevel () {
        this.$http.post(this.API_ENDPOINT + '/payment/viplevel/account/set', {'id': this.changeId, 'newLevel': this.cVIPLevel}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.searchVIPLevelAccount()
            this.cancelChangeVIPLevel()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'VIP Level Changed')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      assignVIPLevel () {
        this.$http.post(this.API_ENDPOINT + '/payment/viplevel/account/assign', {'accountId': this.assignId, 'accountName': this.assignAccountName, 'level': this.aVIPLevel}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.searchVIPLevelAccount()
            this.cancelAssignLevel()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'VIP Level Assigned')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      removeVIPLevel () {
        this.$http.post(this.API_ENDPOINT + '/payment/viplevel/account/remove', {'id': this.removeId}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.searchVIPLevelAccount()
            this.cancelRemoveLevel()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'VIP Level Removed')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      showChangeVIPLevel (id, level, accountId, accountName) {
        this.changeId = id
        this.cVIPLevel = level
        this.cAccountId = accountId
        this.cAccountName = accountName
        this.$refs.changeVIPLevel.show()
      },
      cancelChangeVIPLevel () {
        this.$refs.changeVIPLevel.hide()
      },
      showManagementModal () {
        this.$refs.showManagementModal.show()
      },
      hideManagementModal () {
        this.$refs.showManagementModal.hide()
      },
      confirmAssignLevel (id, accountName) {
        this.assignId = id
        this.assignAccountName = accountName
        this.$refs.confirmAssignLevel.show()
      },
      cancelAssignLevel () {
        this.$refs.confirmAssignLevel.hide()
      },
      onAssignModalHide () {
        this.$refs.showManagementModal.show()
      },
      showRemoveVIPLevel (id) {
        this.removeId = id
        this.$refs.removeVIPLevel.show()
      },
      cancelRemoveLevel () {
        this.$refs.removeVIPLevel.hide()
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
      this.getVIPLevels()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelAccountTable.vue